export default __webpack_public_path__ + "static/media/Design.ff903a95.svg";